'use client';
import {LayoutGrid,List} from 'lucide-react';

export default function ViewSwitch({value,onChange}:{value:'grid'|'list';onChange:(v:'grid'|'list')=>void}){
  return <div className="view-switch" role="group" aria-label="视图切换">
    <button type="button" aria-label="列表" title="列表" className={value==='list'?'active':''} onClick={()=>onChange('list')}><List size={15}/></button>
    <button type="button" aria-label="卡片" title="卡片" className={value==='grid'?'active':''} onClick={()=>onChange('grid')}><LayoutGrid size={15}/></button>
  </div>;
}
